export const PORTAL_CANDIDAT_URL = '/portal-candidat';